import React, { useEffect, useState } from "react";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import UseTitle from "../../components/useTitle";
import "./CampaignAddXP.scss";

const CampaignAddXP = ({ campaign, setIsAddXP, setRefresh }) => {
  // Définition du titre de la page
  UseTitle("Campagne - Ajouter de l'expérience");

  const [listCharacters] = useState(campaign.characters);
  const [charactersXP, setCharactersXP] = useState({});
  const [charactersSelected, setCharactersSelected] = useState([]);
  const [minXPSelected, setMinXPSelected] = useState(0);
  const [checkButton, setCheckButton] = useState(false);

  const handleAddXP = () => {
    // TODO : Ajouter les vérifications (xp vide, ...)

    api
      .post("/addxp/", charactersXP)
      .then(() => {
        setRefresh(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleXPChange = (characterId, xp) => {
    // si on retire de l'expérience
    if (xp < 0) {
      if (charactersXP[characterId] === undefined) return;
      if (charactersXP[characterId] + xp < 0) {
        setCharactersXP({ ...charactersXP, [characterId]: 0 });
      } else {
        setCharactersXP({
          ...charactersXP,
          [characterId]: charactersXP[characterId] + xp,
        });
      }
      // si on ajoute de l'expérience
    } else {
      if (charactersXP[characterId] === undefined) {
        setCharactersXP({ ...charactersXP, [characterId]: xp });
      } else {
        setCharactersXP({
          ...charactersXP,
          [characterId]: charactersXP[characterId] + xp,
        });
      }
    }
  };

  const handleSelectCharacter = (characterId) => {
    if (charactersSelected.includes(characterId)) {
      setCharactersSelected(
        charactersSelected.filter((id) => id !== characterId)
      );
    } else {
      setCharactersSelected([...charactersSelected, characterId]);
    }
  };

  const handleSelectAllCharacters = () => {
    if (charactersSelected.length === listCharacters.length) {
      setCharactersSelected([]);
    } else {
      setCharactersSelected(listCharacters.map((character) => character.id));
    }
  };

  const handleXPChangeSelectedCharacters = (xp) => {
    setCharactersXP((prevState) => {
      const newXP = { ...prevState };
      charactersSelected.forEach((characterId) => {
        newXP[characterId] = (newXP[characterId] || 0) + xp;
        if (newXP[characterId] <= 0) {
          delete newXP[characterId];
        }
      });
      return newXP;
    });
  };

  useEffect(() => {
    for (const id in charactersXP) {
      if (charactersXP[id] <= 0) {
        delete charactersXP[id];
      }
    }
    if (Object.keys(charactersXP).length > 0) {
      setCheckButton(true);
    } else {
      setCheckButton(false);
    }
  }, [charactersXP]);

  useEffect(() => {
    if (charactersSelected.length > 0) {
      const minXP = Math.min(
        ...charactersSelected.map((id) =>
          charactersXP[id] !== undefined ? charactersXP[id] : 0
        )
      );
      setMinXPSelected(minXP);
    } else {
      setMinXPSelected(0);
    }
  }, [charactersSelected, charactersXP]);

  return (
    <div className="add-xp">
      {listCharacters.length > 0 && (
        <>
          <h1>{campaign.name} - Ajouter des points d'expérience</h1>
          <p>
            Choisissez les personnages à qui ajouter des points d'expérience
          </p>
          <div className="list-add">
            <div className="add select">
              <span className="selected">
                <input
                  type="checkbox"
                  id="selected"
                  checked={listCharacters.length === charactersSelected.length}
                  onChange={handleSelectAllCharacters}
                />
                <label htmlFor="selected">Sélectionné(s)</label>
              </span>
              <div className="buttons">
                <button
                  className={minXPSelected < 5 ? "bt disabled" : "bt"}
                  disabled={minXPSelected < 5}
                  onClick={() => handleXPChangeSelectedCharacters(-5)}
                >
                  -5
                </button>
                <button
                  className={minXPSelected < 10 ? "bt disabled" : "bt"}
                  disabled={minXPSelected < 10}
                  onClick={() => handleXPChangeSelectedCharacters(-10)}
                >
                  -10
                </button>
                <button
                  className={
                    charactersSelected.length === 0 ? "bt disabled" : "bt"
                  }
                  disabled={charactersSelected.length === 0}
                  onClick={() => handleXPChangeSelectedCharacters(10)}
                >
                  +10
                </button>
                <button
                  className={
                    charactersSelected.length === 0 ? "bt disabled" : "bt"
                  }
                  disabled={charactersSelected.length === 0}
                  onClick={() => handleXPChangeSelectedCharacters(5)}
                >
                  +5
                </button>
              </div>
            </div>
            {listCharacters.map((character) => (
              <div className="add" key={character.id}>
                <span className="character">
                  <input
                    type="checkbox"
                    id={`character-${character.id}`}
                    checked={charactersSelected.includes(character.id)}
                    onChange={() => handleSelectCharacter(character.id)}
                  />
                  <label className="name" htmlFor={`character-${character.id}`}>
                    {character.name}{" "}
                    <small>({character.user_proprietary})</small>
                  </label>
                  <span className="xp">{charactersXP[character.id] || 0}</span>
                </span>
                <div className="buttons">
                  <button
                    className={
                      charactersXP[character.id] === undefined ||
                      charactersXP[character.id] < 5
                        ? "bt disabled"
                        : "bt"
                    }
                    disabled={
                      charactersXP[character.id] === undefined ||
                      charactersXP[character.id] < 5
                    }
                    onClick={() => handleXPChange(character.id, -5)}
                  >
                    -5
                  </button>
                  <button
                    className={
                      charactersXP[character.id] === undefined ||
                      charactersXP[character.id] < 10
                        ? "bt disabled"
                        : "bt"
                    }
                    disabled={
                      charactersXP[character.id] === undefined ||
                      charactersXP[character.id] < 10
                    }
                    onClick={() => handleXPChange(character.id, -10)}
                  >
                    -10
                  </button>
                  <button
                    className="bt"
                    onClick={() => handleXPChange(character.id, 10)}
                  >
                    +10
                  </button>
                  <button
                    className="bt"
                    onClick={() => handleXPChange(character.id, 5)}
                  >
                    +5
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="buttons">
            <button
              className={checkButton ? "bt" : "bt disabled"}
              disabled={!checkButton}
              onClick={handleAddXP}
            >
              Ajouter XP
            </button>
            <button className="bt" onClick={() => setIsAddXP(false)}>
              Annuler
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CampaignAddXP;
